import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CreditorFunding } from '../types'

interface FundingState {
    loading: boolean
    fundingOverview: CreditorFunding[]
    error: Error | string | null
  }

const initialState: FundingState = {
    loading: false,
    fundingOverview: [],
    error: null
}

export const fundingSlice = createSlice({
    name: 'funding',
    initialState,
    reducers: {
        loading: state => {
            state.loading = true
            state.error = null
        },
        fundingOverviewFetched: (state, action: PayloadAction<CreditorFunding[]>) => {
            state.loading = false
            state.fundingOverview = action.payload
        },
        fundingOverviewFetchFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
        postfundingTransactionCheckRequested: (state) => {
            state.loading = false
        },
        postfundingTransactionCheckRequestFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
        prefundingTransactionCheckRequested: (state) => {
            state.loading = false
        },
        prefundingTransactionCheckRequestFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
    }
})

export const { 
    loading, 
    fundingOverviewFetched, 
    fundingOverviewFetchFailure,
    postfundingTransactionCheckRequested,
    postfundingTransactionCheckRequestFailure,
    prefundingTransactionCheckRequested,
    prefundingTransactionCheckRequestFailure
} = fundingSlice.actions

export default fundingSlice.reducer